<script setup lang="ts">
import BillingDataForm from './components/BillingDataForm.vue';
import ShippingTypeSelection from './components/ShippingTypeSelection.vue';
import ShippingModeSelection from './components/ShippingModeSelection.vue';
import ShippingAddressForm from './components/ShippingAddressForm.vue';
import Payment from './components/Payment.vue';
import CheckoutSummary from './components/CheckoutSummary.vue';
import CartCountdown from './components/CartCountdown.vue';
import useCheckout from './composables/useCheckout';
import { computed, onMounted, toRef, toValue, watch } from 'vue';
import {i18n} from "@/libs/wordpress.facade";
import useItlpApi from './composables/useItlpApi';
import GlobalAlertComponent from './components/GlobalAlertComponent.vue';

const {step, wooCart} = useCheckout();

wooCart.refreshCart();

const cart = toRef(() => wooCart.cart.value)

/*watch(() => toValue(wooCart.cart), (cart) => {
	if(cart && cart.items && cart.items.length == 0){ // just for test
		wooCart.addCartItem({id: 61, quantity: 1, variation: []});
	}
});*/

const stepLabel = computed(() => {
	if(step.value == 0) return i18n.__('Modalità di gestione', 'italpreziosi');
	if(step.value == 1) return i18n.__('Dati di fatturazione', 'italpreziosi');
	if(step.value == 2) return i18n.__('Metodo di consegna', 'italpreziosi');
	if(step.value == 3) return i18n.__('Indirizzo di spedizione', 'italpreziosi');
	if(step.value == 4) return i18n.__('Metodo di pagamento', 'italpreziosi');
	return '';
});

const itlpApi = useItlpApi();
itlpApi.loadCountries();

watch(step, () => {
	setTimeout(() => {
		window.scroll({
			top: 100,
			left: 0,
			behavior: 'smooth'
		});
	}, 100);
});

</script>

<template lang="pug">
div.itlp-checkout-container
	.itlp-checkout-main-section(:data-checkout-step="step" :data-loading="Boolean(wooCart.requesting.value)")
		.itlp-checkout-section-header
			.itlp-checkout-section-label {{i18n.__('Check-out', 'italpreziosi')}}
			.itlp-checkout-section-extra-label Step {{ step + 1 }}/5 - {{ stepLabel }}
		global-alert-component
		.itlp-checkout-section-content(v-if='wooCart.cart.value')
			cart-countdown
			shipping-mode-selection(v-if='step==0' key="shipping-mode-step")
			billing-data-form(v-if='step==1' key="billing-data-step")
			shipping-type-selection(v-if='step==2' key="shipping-type-step")
			shipping-address-form(v-if='step==3' key="shipping-address-step")
			payment(v-if='step==4' key="payment-step")
		.itlp-checkout-section-content.itlp-checkout-section-content-loading(v-if='!wooCart.cart.value')
	.itlp-checkout-side-section
		.itlp-checkout-section-header
			.itlp-checkout-section-label {{i18n.__('Riepilogo ordine', 'italpreziosi')}}
		.itlp-checkout-section-content
			checkout-summary
		.itlp-checkout-section-footer
			.itlp-checkout-section-footer-text {{i18n.__('Acquista in sicurezza con questi metodi', 'italpreziosi')}}
			img.itlp-checkout-section-footer-visa-icon(decoding="async" src='https://shop.italpreziosi.it/wp-content/uploads/2025/05/logo-visa.svg' alt="Logo Visa")
			img.itlp-checkout-section-footer-mastercard-icon(decoding="async" src='https://shop.italpreziosi.it/wp-content/uploads/2025/05/logo-mastercard.svg' alt="Logo Mastercard")
			img.itlp-checkout-section-footer-bank-icon(decoding="async" src='https://shop.italpreziosi.it/wp-content/uploads/2025/05/logo-bank-transfer.svg' alt="Logo Bonifico Bancario")
</template>

<style>

.itlp-checkout-container{
	width: 100%;
	align-items: start;
	justify-content: space-between;
}

.itlp-checkout-container,
.itlp-checkout-section-header{
	display: flex;
	flex-direction: row;
}

.itlp-checkout-main-section{
	flex: 1;
}
	
</style>
